import { XMarkIcon } from '@heroicons/react/20/solid'
import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'
import { useChatbotStore } from 'store/useChatbotStore'
import { ChatBubble } from './ChatBubble'
import { useChatBot } from 'hooks/selectors/chatbots/useChatbot'

export const ChatHeading = ({ isIframed }: { isIframed: boolean }) => {
  const { setOpen } = useChatbotStore()
  const chatbot = useChatbotSettingsStore((state) => state.chatbot)
  const iconPresignedUrl = useChatbotSettingsStore(
    (state) => state.iconPresignedUrl
  )
  const { iconLoading } = useChatBot({ id: chatbot.id || '' })

  return (
    <div className="z-10 border-b border-gray-200 bg-gray-50 py-4 shadow">
      <div className="flex w-full items-center justify-between px-4 py-2">
        <div className="flex items-center">
          <div className="relative mr-2">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <ChatBubble
              isLoading={iconLoading}
              presignedUrl={iconPresignedUrl}
              visualOnly
              size={40}
            />
            <div className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full border-2 border-white bg-green-500"></div>
          </div>
          <div className="flex flex-col">
            <p className="ml-2 select-none text-2xl font-bold">
              {chatbot?.name}
            </p>
            <p className="ml-2 -mt-1 select-none text-sm text-gray-400">
              Online
            </p>
          </div>
        </div>
        {!isIframed && (
          <div
            className="-mt-8 -mr-2 flex cursor-pointer items-center justify-end pb-2"
            onClick={() => setOpen(false)}
          >
            <XMarkIcon className="h-7 w-7 text-gray-500" />
            <p className="sr-only">Close</p>
          </div>
        )}
      </div>
    </div>
  )
}

const Skeleton = () => {
  return (
    <div className="h-10 w-10 animate-pulse rounded-full bg-toasty-blue-300"></div>
  )
}
